import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import SydActionMenu from '../../../../../commonDesign/SydActionMenu'
import ChangeDatasourceSchemaDialog from '../../dialogs/ChangeDatasourceSchemaDialog'
import ChangeDatasourceCodeDialog from '../../dialogs/ChangeDatasourceCodeDialog'
import ModifyDatasourceAiEnabledDialog from '../../dialogs/ModifyDatasourceAiEnabledDialog'
import ModifyDatasourceDeprecatedDialog from '../../dialogs/ModifyDatasourceDeprecatedDialog'

function DatasourceActionsMenu ({ datasource }) {
  const changeDatasourceSchemaDialog = useRef(null)
  const changeDatasourceCodeDialog = useRef(null)
  const modifyDatasourceAiEnabledDialog = useRef(null)
  const modifyDatasourceDeprecatedDialog = useRef(null)

  const actions = useMemo(() => [
    {
      key: 'change-schema',
      label: 'Change Schema',
      icon: 'database',
      onClick: (ds) => changeDatasourceSchemaDialog.current.open(ds)
    },
    {
      key: 'change-code',
      label: 'Change Code',
      icon: 'edit',
      onClick: (ds) => changeDatasourceCodeDialog.current.open(ds)
    },
    {
      key: 'ai-settings',
      label: 'AI Settings',
      icon: 'sparkles',
      onClick: (ds) => modifyDatasourceAiEnabledDialog.current.open(ds)
    },
    {
      key: 'deprecated',
      label: 'Deprecation Status',
      icon: 'archive',
      onClick: (ds) => modifyDatasourceDeprecatedDialog.current.open(ds)
    }
  ], [])

  return (
    <>
      <SydActionMenu actions={actions} subject={datasource} />
      <ChangeDatasourceSchemaDialog ref={changeDatasourceSchemaDialog} />
      <ChangeDatasourceCodeDialog ref={changeDatasourceCodeDialog} />
      <ModifyDatasourceAiEnabledDialog ref={modifyDatasourceAiEnabledDialog} />
      <ModifyDatasourceDeprecatedDialog ref={modifyDatasourceDeprecatedDialog} />
    </>
  )
}

DatasourceActionsMenu.propTypes = {
  datasource: PropTypes.any
}

export default DatasourceActionsMenu
